var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCc(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 196.445,
    height: 60.961,
    viewBox: "0 0 196.445 60.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8c51ff;}.b{fill:#c4b8fa;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-335.877 -310.926)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(439.193 310.926)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M561.085,351.581a18.577,18.577,0,0,0-1.592-6.992,19.845,19.845,0,0,0-5.544-7.7c-2.161-2.465-4.121-4.785-3.758-6.331,1.029-4.38,4.936-.316,8.842-3.279,1.241-.941,1.848-1.927,1.416-2.517a12.663,12.663,0,0,1-1.284-2.937c-.412-1.286.918-2.2-1.114-4.877-.751-.989-1.928-2.274-1.928-2.274s.123-.389.334-.9l-.052-.012a8.62,8.62,0,0,1,.736-1.409c.658-.982,1.008-1.431,1.007-1.432-13.8-.006-26.338,12.551-28.438,25.747a32.409,32.409,0,0,0,4.185,21.614,28.494,28.494,0,0,0,9.779,9.011,15.445,15.445,0,0,1-18.228-15.211,15.38,15.38,0,0,1,1.192-5.966,2.168,2.168,0,1,0-4-1.673,19.813,19.813,0,0,0,22.891,26.9v-6.936h0a8.571,8.571,0,0,0-2.581-6.019,37.781,37.781,0,0,0-3.123-2.27,10.1,10.1,0,0,1-2.393-2.827,11.325,11.325,0,0,1-1.162-2.767,16.56,16.56,0,0,1-.394-2.976h22.149a16.571,16.571,0,0,1-.394,2.976,11.32,11.32,0,0,1-1.162,2.767,10.1,10.1,0,0,1-2.393,2.827,37.687,37.687,0,0,0-3.124,2.27,8.568,8.568,0,0,0-2.58,6.019h0v6.013a2.223,2.223,0,0,0,.324-.176,19.869,19.869,0,0,0,8.185-6.312A18.532,18.532,0,0,0,561.085,351.581Z",
    transform: "translate(-521.11 -310.926)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M569.649,378.712l-4.565,2.977-4.566,2.977a5.451,5.451,0,1,0,9.131-5.955Z",
    transform: "translate(-538.538 -340.903)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M347.516,385.409a3.548,3.548,0,0,0-3.445-2.167,3.93,3.93,0,0,0,.112,7.833,3.519,3.519,0,0,0,3.333-2.055h4.694a8.279,8.279,0,0,1-16.333-1.889,8.249,8.249,0,0,1,16.305-1.722Z",
    transform: "translate(0 -30.077)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M378.324,395.3V393.66h-.056c-.667,1.417-1.889,2.138-3.972,2.138-3.25,0-5.944-1.944-5.944-6.333v-9.583h4.611v8.639c0,2.027.722,2.972,2.472,2.972s2.639-1.166,2.639-3.055v-8.555h4.611V395.3Z",
    transform: "translate(-14.362 -30.495)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M400.278,391.224V370.669h4.612v20.555Z",
    transform: "translate(-28.48 -26.421)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M414.361,391.224V379.308h-2.277v-3.5h2.277v-5.139h4.611v5.139h2.222v3.5h-2.222v11.917Z",
    transform: "translate(-33.702 -26.421)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M441.88,395.3V393.66h-.056c-.667,1.417-1.889,2.138-3.972,2.138-3.25,0-5.944-1.944-5.944-6.333v-9.583h4.61v8.639c0,2.027.722,2.972,2.473,2.972s2.639-1.166,2.639-3.055v-8.555h4.61V395.3Z",
    transform: "translate(-42.468 -30.495)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M463.535,394.881V379.465h4.333V381.1h.056a3.787,3.787,0,0,1,3.861-2.166v4.638c-2.75.028-3.639,1.056-3.639,2.806v8.5Z",
    transform: "translate(-56.455 -30.077)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M484.328,388.575a3.45,3.45,0,0,0,3.611,2.917,3.242,3.242,0,0,0,2.806-1.444h4.722c-1.472,3.361-4.278,5.333-7.528,5.333a8.223,8.223,0,1,1,8.056-8.027,5.857,5.857,0,0,1-.112,1.222Zm7.056-3.111a3.641,3.641,0,0,0-7,0Z",
    transform: "translate(-63.636 -30.077)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M616.688,385.409a3.548,3.548,0,0,0-3.445-2.167,3.93,3.93,0,0,0,.111,7.833,3.52,3.52,0,0,0,3.334-2.055h4.694a8.279,8.279,0,0,1-16.334-1.889,8.25,8.25,0,0,1,16.306-1.722Z",
    transform: "translate(-119.038 -30.077)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M649.88,394.881v-1.667h-.055c-.667,1.361-2.5,2.194-4.529,2.194-4.555,0-7.722-3.583-7.722-8.25,0-4.555,3.306-8.221,7.722-8.221a5.227,5.227,0,0,1,4.529,2.166h.055v-1.639h4.611v15.416Zm0-7.722a3.912,3.912,0,0,0-3.917-3.917,3.931,3.931,0,1,0,3.917,3.917Z",
    transform: "translate(-133.422 -30.077)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M674.021,391.224V379.308h-2.279v-3.5h2.279v-5.139h4.61v5.139h2.222v3.5h-2.222v11.917Z",
    transform: "translate(-148.532 -26.421)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCc);
export default __webpack_public_path__ + "static/media/cc.c44872c50a2fd8cbb8983e2462506e97.svg";
export { ForwardRef as ReactComponent };